import Vue from "vue";
import VueRouter from "vue-router";
import CustomerRouter from "./CustomerRouter";
import WalletRouter from "./WalletRouter";
import ConfigurationRouter from "./ConfigurationRouter";
import ReportRouter from "./ReportRouter";
import ProfileRouter from "./ProfileRouter";

import store from "@/store/index";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("@/views/Home.vue"),
            meta: {
                pageTitle: "Home",
                breadcrumb: [
                    {
                        text: "Home",
                        active: true,
                    },
                ],
                requiresAuth: true,
            },
        },
        {
            path: "/admin-dashboard",
            name: "admin-dashboard",
            component: () => import("@/views/dashboard/AdminDashboard.vue"),
            meta: {
                pageTitle: "Services",
                breadcrumb: [
                    {
                        text: "Services",
                        active: true,
                    },
                ],
                requiresAuth: true,
            },
        },
        {
            path: "/inventory",
            name: "inventory",
            component: () => import("@/views/Inventory.vue"),
            meta: {
                pageTitle: "Inventory",
                breadcrumb: [
                    {
                        text: "Inventory",
                        active: true,
                    },
                ],
                requiresAuth: true,
            },
        },
        {
            path: "/payment-history",
            name: "payment-history",
            component: () => import("@/views/PaymentHistory.vue"),
            meta: {
                pageTitle: "Wallet History",
                breadcrumb: [
                    {
                        text: "Wallet History",
                        active: true,
                    },
                ],
                requiresAuth: true,
            },
        },
        ...CustomerRouter,
        ...WalletRouter,
        ...ConfigurationRouter,
        ...ReportRouter,
        ...ProfileRouter,

        {
            path: "/notifications",
            name: "notifications",
            component: () => import("@/views/notifications/ActiveList.vue"),
            meta: {
                pageTitle: "Notifications",
                breadcrumb: [
                    {
                        text: "Notifications",
                        active: true,
                    },
                ],
                requiresAuth: true,
            },
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/views/Login.vue"),
            meta: {
                pageTitle: "Login",
                layout: "full",
            },
        },
        {
            path: "/forgetpassword",
            name: "forgetpassword",
            component: () => import("@/views/ResetPassword.vue"),
            meta: {
                pageTitle: "Reset Password",
                layout: "full",
            },
        },
        {
            path: "/not-authorized",
            name: "not-authorized",
            component: () => import("@/views/error/NotAuthorized.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/error-404",
            name: "error-404",
            component: () => import("@/views/error/Error404.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "*",
            redirect: "error-404",
        },
    ],
});

router.beforeEach((to, from, next) => {
    window.document.title =
        to.meta && to.meta.pageTitle
            ? to.meta.pageTitle + " | MiME Self-Care"
            : "MiME Self-Care";
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters["app/isLoggedIn"]) {
            if (!store.getters["app/isMenuPermissionLoaded"]) {
                //store.dispatch("app/setAuthHeaderToken");
                store.dispatch("app/fetchAllMenus").then(() => {
                    if (
                        to.name == "notifications" ||
                        to.name == "account-setting"
                    ) {
                        ///Nothing to do - ignore permissions check
                        //Proceed routes which has no permissions setup
                    } else if (
                        !store.getters["app/hasAccessMenuPermission"](to.name)
                    ) {
                        next("/not-authorized");
                    }
                });
            } else {
                if (
                    to.name == "notifications" ||
                    to.name == "account-setting"
                ) {
                    //Nothing to do - ignore permissions check
                    //Proceed routes which has no permissions setup
                } else if (
                    !store.getters["app/hasAccessMenuPermission"](to.name)
                ) {
                    next("/not-authorized");
                }
            }

            next();
            return;
        }

        next({
            path: "/login",
        });
    } else {
        next();
    }
});

export default router;
